import { render, staticRenderFns } from "./MultiChoiceCardsTable.vue?vue&type=template&id=4a62eb46&"
import script from "./MultiChoiceCardsTable.vue?vue&type=script&lang=ts&"
export * from "./MultiChoiceCardsTable.vue?vue&type=script&lang=ts&"
import style0 from "./MultiChoiceCardsTable.vue?vue&type=style&index=0&id=4a62eb46&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports